import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class ResendInviteTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Resend Invite';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.CLINIC_SETTINGS.RESEND_INVITE, ($e, data) => {
            this.trackButtonEventSegment(data);
        });
    }
}
